import { motion } from "framer-motion";

/**
 * Consistent empty-state used across listings (no profiles, no chats, no payments...)
 */
export default function EmptyState({
  Icon,
  title,
  description,
  action,
  tone = "brand",
}) {
  const tones = {
    brand: "bg-brand-50 text-brand-600",
    amber: "bg-amber-50 text-amber-600",
    rose: "bg-rose-50 text-rose-600",
    emerald: "bg-emerald-50 text-emerald-600",
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className="card flex flex-col items-center px-6 py-12 text-center"
    >
      {Icon && (
        <div className={`inline-flex h-16 w-16 items-center justify-center rounded-2xl ${tones[tone] || tones.brand}`}>
          <Icon size={26} />
        </div>
      )}
      <h3 className="mt-4 font-display text-lg font-bold text-ink-800">{title}</h3>
      {description && (
        <p className="mt-1.5 max-w-sm text-[13.5px] leading-6 text-ink-500">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </motion.div>
  );
}
